// The two sections a picker's table splits into — for <Table groups getRowGroup>.

export const PICKER_GROUP = Object.freeze({
  suggestion: 'suggestion',
  linked: 'linked',
  other: 'other',
});

// Rows the server ranked as matching every preference, then the rest (row.isSuggestion).
export const buildSuggestionGroups = (t) => [
  { id: PICKER_GROUP.suggestion, label: t('PICKER_GROUP_SUGGESTION') },
  { id: PICKER_GROUP.other, label: t('PICKER_GROUP_OTHER') },
];

export const getSuggestionGroup = (row) =>
  row.isSuggestion ? PICKER_GROUP.suggestion : PICKER_GROUP.other;

// Rows already linked to the record, then the rest (row.isLinked); the keys name the entity.
export const buildLinkedGroups = (t, { linkedKey, otherKey }) => [
  { id: PICKER_GROUP.linked, label: t(linkedKey) },
  { id: PICKER_GROUP.other, label: t(otherKey) },
];

export const getLinkedGroup = (row) => (row.isLinked ? PICKER_GROUP.linked : PICKER_GROUP.other);
